// extracted by mini-css-extract-plugin
export default {"bt_container":"DonatePage_bt_container__2UWBk","bt_ukraine_image":"DonatePage_bt_ukraine_image__4VRrN"};